module.exports = __webpack_public_path__ + "static/media/gestioneFeedback.be28c153.png";